import { defineMessages } from 'react-intl';

export default defineMessages({
  concernedExpertises: {
    id: 'expert_expertise_concerned_expertises.title',
  },
  noExpertiseAdded: {
    id: 'expert_expertise_concerned_expertises.no_expertise_added',
  },
  addExpertise: {
    id: 'expert_expertise_concerned_expertises.add_expertise',
  },
  doesNotConcernMe: {
    id: 'expert_expertise_concerned_expertises.does_not_concern_me',
  },
  judiciaryExpertise: {
    id: 'expert_expertise_concerned.judiciary_expertise',
  },
  consultingExpertise: {
    id: 'expert_expertise_concerned.consulting_expertise',
  },
  appreciationExpertise: {
    id: 'expert_expertise_concerned.appreciation_expertise',
  },
  back: {
    id: 'fill_expertise.back',
  },
  confirm: {
    id: 'fill_expertise.confirm',
  },
  warningCreationFeeNote: {
    id: 'toast.success.warning_creation_fee_note.title',
  },
  successMessage: {
    id: 'toast.success.createExpertiseVictim.title',
  },
  successMessageUpdate: {
    id: 'toast.success.updateExpertiseVictim.title',
  },
  consultingReport: {
    id: 'expert_expertise.tab_consulting_report.title',
  },
  noticeDeficiency: {
    id: 'expert_expertise.tab_notice_deficiency.title',
  },
  postponementsExpertise: {
    id: 'expert_expertise.tab_postponements_expertise.title',
  },
  successDialogPrimaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.primary_button_title',
  },
  successDialogSecondaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.secondary_button_title',
  },
  successAppealAdd: {
    id: 'success_dialog.fee_note',
  },
  doNotGenerateFeeNote: {
    id: 'success_dialog.do_not_generate_fee_note',
  },
  judiciaryExpertiseReport: {
    id: 'court_manager_legal_proceedings_page.expert_report_tab.title',
  },
});
